module.exports = __webpack_public_path__ + "img/9788932915753.4fdccf48.jpg";